<div [class.rtl]="currLang == 'ar'" class="modal" id="addStaffModal" tabindex="-1" role="dialog" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content" [attr.dir]="currLang == 'ar' ? 'rtl' : 'ltr'">
            <div class="modal-header">
                <h5 class="modal-title">{{modalTitle}}</h5>
                <div class="header-btns">
                    <button *ngIf="formFlag==='view'" class="btn btn-primary edit-btn"
                        (click)="editStaff()" [appGuardCtaByPermission]="'StaffEdit'">{{'add-staff.edit' | translate}}</button>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
            <div class="modal-body">
                <form [formGroup]="addStaffForm" class="staff-panes">
                    <!-- details pane: never moves or changes when the role changes (AC 1) -->
                    <div class="staff-panes__details">
                        <!-- staff photo: same picker and upload as before the revamp (read-only in View) -->
                        <div class="img-section">
                            <div class="avatar-picker" (click)="changeStaffProfile()"
                                [class.avatar-picker--readonly]="formFlag === 'view'">
                                <img *ngIf="image" class="avatar-picker__image" src="{{image}}">
                                <svg *ngIf="!image" class="avatar-picker__placeholder" id="staff"
                                    xmlns="http://www.w3.org/2000/svg" width="39.5" height="45.408"
                                    viewBox="0 0 39.5 45.408">
                                    <path id="Path_1481" data-name="Path 1481"
                                        d="M41.4,36.893V30H19v6.893a11.2,11.2,0,0,0,22.4,0Z"
                                        transform="translate(-10.452 -9.731)" fill="#707070" />
                                    <path id="Path_1482" data-name="Path 1482"
                                        d="M26,51.74v3.783l5.17.741,5.17-.741V51.74A12.853,12.853,0,0,1,26,51.74Z"
                                        transform="translate(-11.42 -13.449)" fill="#707070" />
                                    <path id="Path_1483" data-name="Path 1483" d="M47,35.17A2.585,2.585,0,1,0,47,30Z"
                                        transform="translate(-14.325 -9.115)" fill="#707070" />
                                    <path id="Path_1484" data-name="Path 1484"
                                        d="M10.6,12.553l18.44,6.911,18.44-6.911L29.04,4.1Z"
                                        transform="translate(-9.29 -4.1)" fill="#707070" />
                                    <path id="Path_1485" data-name="Path 1485"
                                        d="M43.478,55H35.723v1.723a.862.862,0,0,1-.741.853l-6.032.862a.849.849,0,0,1-.241,0l-6.032-.862a.862.862,0,0,1-.741-.853V55H14.181a5.185,5.185,0,0,0-5.1,4.308h39.5A5.185,5.185,0,0,0,43.478,55Z"
                                        transform="translate(-9.08 -13.9)" fill="#707070" />
                                    <path id="Path_1486" data-name="Path 1486"
                                        d="M30.064,23.284a.888.888,0,0,1-.3-.052L18,18.82v7.91H42.127V18.82L30.365,23.232a.888.888,0,0,1-.3.052Z"
                                        transform="translate(-10.314 -7.006)" fill="#707070" />
                                    <path id="Path_1487" data-name="Path 1487"
                                        d="M16.585,35.17V30a2.585,2.585,0,0,0,0,5.17Z" transform="translate(-9.761 -9.115)"
                                        fill="#707070" />
                                </svg>
                                <svg class="avatar-picker__camera" xmlns="http://www.w3.org/2000/svg" width="25.673"
                                    height="25.673" viewBox="0 0 25.673 25.673">
                                    <g id="Group_5234" data-name="Group 5234" transform="translate(-348 -189)">
                                        <path id="Path_5432" data-name="Path 5432"
                                            d="M12.836,0A12.836,12.836,0,1,0,25.673,12.836,12.851,12.851,0,0,0,12.836,0Zm0,0"
                                            transform="translate(348 189)" fill="#1d71d3" />
                                        <g id="camera" transform="translate(353.41 195.492)">
                                            <g id="Group_5233" data-name="Group 5233" transform="translate(0)">
                                                <g id="Group_5232" data-name="Group 5232" transform="translate(0 0)">
                                                    <path id="Path_5478" data-name="Path 5478"
                                                        d="M15.19,46.727a1.689,1.689,0,0,0-1.24-.523H11.471v-.03a1.341,1.341,0,0,0-.4-.971,1.367,1.367,0,0,0-.971-.4H5.616a1.377,1.377,0,0,0-1.389,1.374v.03H1.762a1.689,1.689,0,0,0-1.24.523A1.776,1.776,0,0,0,0,47.966V55.4a1.689,1.689,0,0,0,.523,1.24,1.776,1.776,0,0,0,1.24.523H13.95a1.689,1.689,0,0,0,1.24-.523,1.776,1.776,0,0,0,.523-1.24V47.966A1.689,1.689,0,0,0,15.19,46.727ZM14.936,55.4h-.015a.969.969,0,0,1-.971.971H1.762A.969.969,0,0,1,.792,55.4V47.966A.969.969,0,0,1,1.762,47H4.645a.4.4,0,0,0,.4-.4v-.433a.562.562,0,0,1,.582-.582H10.1a.562.562,0,0,1,.582.582v.433a.4.4,0,0,0,.4.4h2.883a.969.969,0,0,1,.971.971Z"
                                                        transform="translate(0 -44.8)" fill="#fff" />
                                                    <path id="Path_5479" data-name="Path 5479"
                                                        d="M115.674,130.8a3.672,3.672,0,1,0,2.6,1.075A3.681,3.681,0,0,0,115.674,130.8Zm2.031,5.72a2.885,2.885,0,0,1-4.062,0,2.855,2.855,0,0,1-.836-2.031,2.919,2.919,0,0,1,.836-2.031,2.855,2.855,0,0,1,2.031-.836,2.919,2.919,0,0,1,2.031.836,2.855,2.855,0,0,1,.836,2.031A2.8,2.8,0,0,1,117.705,136.52Z"
                                                        transform="translate(-107.818 -127.589)" fill="#fff" />
                                                    <circle id="Ellipse_655" data-name="Ellipse 655" cx="0.732" cy="0.732"
                                                        r="0.732" transform="translate(12.441 3.196)" fill="#fff" />
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                            <input #fileUploadInput (change)="onFileSelected($event.target.files)" type="file"
                                style="display: none;" [disabled]="formFlag==='view'">
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>{{'add-staff.role' | translate}}</mat-label>
                            <mat-select (selectionChange)="getAssignPartState()" formControlName="role_type"
                                [disabled]="formFlag === 'view'">
                                <mat-option *ngFor="let role of roles" [value]="role">{{getRoleName(role)}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{getStaffFormValidation('role_type') || ('add-staff.role-required' | translate)}}</mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>{{'add-staff.staff-name' | translate}}</mat-label>
                            <input matInput formControlName="name" [readonly]="formFlag === 'view'">
                            <mat-error>{{getStaffFormValidation('name')}}</mat-error>
                        </mat-form-field>
                        <!-- one row per field pair; an error under one field moves both columns down together -->
                        <div class="staff-fields-pair">
                            <mat-form-field appearance="outline">
                                <mat-label>{{'add-staff.national-id' | translate}}</mat-label>
                                <!-- the value reads left to right in Arabic too -->
                                <input matInput formControlName="national_id" dir="ltr" class="ltr-value"
                                    data-pii="redact"
                                    [readonly]="formFlag === 'view'|| completedProfile">
                                <mat-error>{{getStaffFormValidation('national_id')}}</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>{{'add-staff.gender' | translate}}</mat-label>
                                <mat-select formControlName="gender"
                                    [disabled]="formFlag === 'view'|| completedProfile">
                                    <mat-option value="female">{{'add-staff.female' | translate}}</mat-option>
                                    <mat-option value="male">{{'add-staff.male' | translate}}</mat-option>
                                </mat-select>
                                <mat-error>{{'add-staff.gender-required' | translate}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="staff-fields-pair phone-no">
                            <mat-form-field class="code" appearance="outline">
                                <mat-label>{{'add-staff.code' | translate}}</mat-label>
                                <mat-select formControlName="country_code" [disabled]="formFlag==='view'">
                                    <ng-container *ngFor="let country of countries">
                                        <mat-option *ngIf="country.selected" [value]="country?.code_plus">
                                            <span class="country-option" dir="ltr">
                                                <img [src]="country?.flag" [alt]="country?.short" [title]="currLang == 'ar'? country.name_ar : country.name">
                                                {{country?.code_plus}}
                                            </span>
                                        </mat-option>
                                    </ng-container>
                                </mat-select>
                                <mat-error>{{getStaffFormValidation('country_code') || ('add-staff.code-required' | translate)}}</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>{{'add-staff.phone' | translate}}</mat-label>
                                <input matInput formControlName="phone" dir="ltr" class="ltr-value" [readonly]="formFlag === 'view'" data-pii="redact">
                                <mat-error>{{getStaffFormValidation('phone')}}</mat-error>
                            </mat-form-field>
                        </div>
                        <mat-form-field appearance="outline">
                            <mat-label>{{'add-staff.email' | translate}}</mat-label>
                            <input matInput formControlName="email" dir="ltr" class="ltr-value" [readonly]="formFlag==='view'">
                            <mat-error>{{getStaffFormValidation('email')}}</mat-error>
                        </mat-form-field>
                    </div>

                    <!-- role pane: what the chosen role needs (AC 2) -->
                    <div class="staff-panes__role" #rolePane>
                        <div *ngIf="roleChangeNotice" class="links-notice links-notice--warning" role="status">
                            <span class="links-notice__icon" aria-hidden="true">i</span>
                            <span class="links-notice__text" [innerHTML]="roleChangeText"></span>
                            <button type="button" class="link-btn links-notice__action"
                                (click)="undoRoleChange()">{{'add-staff.links.undo' | translate}}</button>
                        </div>

                        <!-- no role yet: the pane only asks for one (Figma 01) -->
                        <h4 *ngIf="!roleType" class="links-section__subtitle">{{'add-staff.links.choose-role' | translate}}</h4>

                        <!-- roles with nothing to link and no switches, e.g. Gate, Cafeteria (Figma 07) -->
                        <p *ngIf="hasNothingToSetUp" class="links-empty-role">
                            {{'add-staff.links.nothing-to-set-up' | translate}}</p>

                        <!-- teacher: classes grouped by grade · viewer: grades · security / shared gate: one gate -->
                        <section *ngIf="linkKind" class="links-section">
                            <h3 class="links-section__title">{{'add-staff.links.title.' + linkKind | translate}}</h3>
                            <app-link-chips *ngIf="linkKind !== 'gate'" [chips]="chips" [readonly]="isReadonly"
                                [moreLabel]="moreChipsLabel" (remove)="removeChip($event)"></app-link-chips>

                            <div class="links-box" [class.links-box--reminder]="reminderShown && !hasAnyLink"
                                [class.links-box--gate]="linkKind === 'gate'">
                                <div *ngIf="reminderShown && !hasAnyLink" class="links-notice links-notice--reminder" role="status">
                                    <span class="links-notice__icon" aria-hidden="true">i</span>
                                    <span class="links-notice__title">{{'add-staff.links.reminder.' + linkKind | translate}}</span>
                                </div>
                                <div *ngIf="linksError" class="links-notice links-notice--danger" role="alert">
                                    <span class="links-notice__icon" aria-hidden="true">!</span>
                                    <span class="links-notice__body">
                                        <span class="links-notice__title">{{'add-staff.links.' + linksError + '.title.' + linkKind | translate}}</span>
                                        <span class="links-notice__text">{{'add-staff.links.' + linksError + '.text.' + linkKind | translate}}</span>
                                    </span>
                                    <button *ngIf="linksError === 'failed'" type="button" class="btn btn-primary links-notice__retry"
                                        [disabled]="saving" (click)="retryLinks()">{{'add-staff.links.retry' | translate}}</button>
                                </div>

                                <div class="links-toolbar">
                                    <label class="links-search">
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <circle cx="11" cy="11" r="7" stroke="#0074EC" stroke-width="2"/>
                                            <path d="M20 20l-4-4" stroke="#0074EC" stroke-width="2" stroke-linecap="round"/>
                                        </svg>
                                        <input type="text" [(ngModel)]="linkSearch" [ngModelOptions]="{standalone: true}"
                                            [placeholder]="'add-staff.links.search.' + linkKind | translate"
                                            [disabled]="linksLoading">
                                    </label>
                                    <ng-container *ngIf="linkKind !== 'gate' && !isReadonly">
                                        <button type="button" class="link-btn" [disabled]="linksLoading"
                                            (click)="selectAllVisible()">{{'add-staff.links.select-all' | translate}}</button>
                                        <button type="button" class="link-btn" [disabled]="linksLoading"
                                            (click)="clearVisible()">{{'add-staff.links.clear' | translate}}</button>
                                    </ng-container>
                                </div>

                                <!-- loading skeleton (screen 16) -->
                                <div *ngIf="linksLoading" class="links-list links-list--loading" aria-busy="true">
                                    <span class="links-skeleton" *ngFor="let row of [1, 2, 3, 4, 5]"></span>
                                </div>

                                <ng-container *ngIf="!linksLoading">
                                    <!-- school with no grades yet (screen 15) -->
                                    <p *ngIf="linkKind !== 'gate' && gradesForPane.length === 0" class="links-empty">
                                        {{'add-staff.links.no-grades.before' | translate}}<a href="javascript:void(0)"
                                            (click)="goToGradesAndClasses()">{{'add-staff.links.no-grades.link' | translate}}</a>{{'add-staff.links.no-grades.after' | translate}}
                                    </p>

                                    <ul *ngIf="linkKind === 'classes'" class="links-list">
                                        <li *ngFor="let grade of visibleGradeTree" class="links-grade">
                                            <div class="links-row">
                                                <button type="button" class="links-expand" [class.links-expand--open]="isGradeExpanded(grade)"
                                                    [attr.aria-expanded]="isGradeExpanded(grade)" [attr.aria-label]="grade.name"
                                                    (click)="toggleGradeExpanded(grade)">
                                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                                                        <path d="M3 4.5L6 7.5L9 4.5" stroke="#707070" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>
                                                </button>
                                                <mat-checkbox class="links-check links-check--grade" color="primary"
                                                    [checked]="gradeState(grade) === 'all'"
                                                    [indeterminate]="gradeState(grade) === 'some'"
                                                    [disabled]="isReadonly"
                                                    (change)="toggleGradeClasses(grade)">{{grade.name}}</mat-checkbox>
                                            </div>
                                            <ul *ngIf="isGradeExpanded(grade)" class="links-classes">
                                                <li *ngFor="let clazz of grade.school_classes" class="links-row">
                                                    <mat-checkbox class="links-check" color="primary"
                                                        [checked]="selectedClassIds.has(clazz.id)" [disabled]="isReadonly"
                                                        (change)="toggleClass(clazz)">{{clazz.name}}</mat-checkbox>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>

                                    <ul *ngIf="linkKind === 'grades'" class="links-list">
                                        <li *ngFor="let grade of visibleGrades" class="links-row">
                                            <mat-checkbox class="links-check" color="primary"
                                                [checked]="selectedGradeIds.has(grade.id)" [disabled]="isReadonly"
                                                (change)="toggleGrade(grade)">{{grade.name}}</mat-checkbox>
                                        </li>
                                    </ul>

                                    <ul *ngIf="linkKind === 'gate'" class="links-list" role="radiogroup">
                                        <li *ngFor="let gate of visibleGates" class="links-row">
                                            <label class="links-radio">
                                                <input type="radio" name="staff-gate" [value]="gate.id"
                                                    [checked]="selectedGateId === gate.id" [disabled]="isReadonly"
                                                    (change)="selectGate(gate.id)">
                                                <span>{{gate.name}}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </ng-container>
                            </div>
                        </section>

                        <!-- teacher and viewer notifications -->
                        <section *ngIf="roleType == 'teacher' || roleType == 'supervisor'" class="links-section links-section--toggles">
                            <h4 class="links-section__subtitle">{{'add-staff.links.notifications' | translate}}</h4>
                            <div class="off-container">
                                <span class="toggle">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="earlyDismissalFlag"
                                            (change)="earlyDismissalFlag = !earlyDismissalFlag" [disabled]="formFlag == 'view'">
                                        <span class="slider round"></span>
                                    </label>
                                </span>
                                <span class="px-1 text-container">
                                    <span class="title">{{'add-staff.early-dismissal-title' | translate}}</span>
                                    <span class="info">{{'add-staff.links.early-dismissal-info' | translate}}</span>
                                </span>
                            </div>
                            <div class="off-container">
                                <span class="toggle">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="receiveBusRequestsFlag"
                                            (change)="receiveBusRequestsFlag = !receiveBusRequestsFlag" [disabled]="formFlag == 'view'">
                                        <span class="slider round"></span>
                                    </label>
                                </span>
                                <span class="px-1 text-container">
                                    <span class="title">{{'add-staff.bus-requests-title' | translate}}</span>
                                </span>
                            </div>
                            <div class="off-container">
                                <span class="toggle">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="enableObserverModeFlag"
                                            (change)="enableObserverModeFlag = !enableObserverModeFlag" [disabled]="formFlag == 'view'">
                                        <span class="slider round"></span>
                                    </label>
                                </span>
                                <span class="px-1 text-container">
                                    <span class="title">{{'add-staff.enable-observer-mode-title' | translate}}</span>
                                </span>
                            </div>
                        </section>

                        <!-- school admin and manager: email report switches -->
                        <section *ngIf="roleType == 'school_admin' || roleType == 'manager'" class="links-section links-section--toggles">
                            <h3 class="links-section__title">{{'add-staff.links.email-reports' | translate}}</h3>
                            <div class="off-container">
                                <span class="toggle">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="dailyReportsFlag"
                                            (change)="dailyReportsFlag = !dailyReportsFlag" [disabled]="formFlag == 'view'">
                                        <span class="slider round"></span>
                                    </label>
                                </span>
                                <span class="px-1 text-container">
                                    <span class="title">{{'add-staff.links.daily-report' | translate}}</span>
                                </span>
                            </div>
                            <div class="off-container">
                                <span class="toggle">
                                    <label class="switch">
                                        <input type="checkbox" [checked]="weeklyReportsFlag"
                                            (change)="weeklyReportsFlag = !weeklyReportsFlag" [disabled]="formFlag == 'view'">
                                        <span class="slider round"></span>
                                    </label>
                                </span>
                                <span class="px-1 text-container">
                                    <span class="title">{{'add-staff.links.weekly-report' | translate}}</span>
                                </span>
                            </div>
                        </section>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <!-- the person saved but the links did not: Close only, Retry sits in the role pane -->
                <button *ngIf="linksError" type="button" class="btn btn-outline-primary close-btn"
                    data-dismiss="modal">{{'add-staff.links.close' | translate}}</button>
                <button *ngIf="!linksError && (formFlag ==='edit' || formFlag ==='add')" (click)="saveStaff()"
                    [disabled]="addStaffForm.invalid || saving" type="button" class="btn btn-primary save-btn">{{saveLabelKey
                    | translate}}</button>
            </div>
        </div>
    </div>
    <!-- B1 choice: inside #addStaffModal so it always paints on top of it -->
    <app-national-id-choice-dialog *ngIf="nationalIdChoice" [data]="nationalIdChoice"
        (closed)="onNationalIdChoiceClosed($event)"></app-national-id-choice-dialog>
</div>
<app-error-msg></app-error-msg>
